<template>
  <div
    id="welcomeLeader"
    class="mainCard"
  >
    <mq-layout :mq="['mobile', 'tablet']">
      <el-row
        :gutter="10"
        type="flex"
      >
        <el-col
          :span="12"
        >
          <MyJourney />
        </el-col>
        <el-col
          :span="12"
        >
          <MyNextMeeting />
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <MyLGAs />
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <MyTasks />
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <ActionPlan />
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <Pulse />
        </el-col>
      </el-row>
    </mq-layout>
    <mq-layout mq="laptop+">
      <el-row>
        <MyJourney />
      </el-row>
      <el-row
        :gutter="5"
        type="flex"
      >
        <el-col
          :span="12"
          class="myTasksCol"
        >
          <MyTasks />
        </el-col>
        <el-col :span="7">
          <MyLGAs />
        </el-col>
        <el-col :span="5">
          <MyNextMeeting />
        </el-col>
      </el-row>

      <el-row
        :gutter="5"
        type="flex"
      >
        <el-col :span="12">
          <ActionPlan />
        </el-col>
        <el-col :span="12">
          <Pulse />
        </el-col>
      </el-row>
    </mq-layout>
  </div>
</template>

<script>
import MyJourney from './widgets/MyJourney.vue';
import MyTasks from './widgets/MyTasks.vue';
import MyLGAs from './widgets/MyLGAs.vue';
import MyNextMeeting from './widgets/MyNextMeeting.vue';
import ActionPlan from './widgets/ActionPlan.vue';
import Pulse from './widgets/Pulse.vue';

export default {
  components: {
    MyJourney,
    MyTasks,
    MyLGAs,
    MyNextMeeting,
    ActionPlan,
    Pulse,
  },

  computed: {
    responsiveCol() {
      const col = {};

      if (['mobile', 'tablet'].includes(this.$mq)) {
        col.one = 24;
      } else {
        col.one = 12;
      }

      return col;
    },
  },
};
</script>

<style lang="scss" scoped>
#welcomeLeader {
  .el-row {
    margin-bottom: 15px;
  }
}
</style>
